import { extend, buffer, createEmpty, getCenter } from 'ol/extent';

const extent = {
	extend, buffer, createEmpty, getCenter
};


export {
	extent
}